import React from "react"

export const PoweredBy = () => (
  <span css="font-size: 0.8em; text-align: end; padding: 0;">
    Powered by{` `}<a href="https://algolia.com">Algolia</a>
  </span>
)